export default "<div class=\"container\" *ngIf=\"newsArticle\">\n  <div [innerHTML]=\"newsArticle.Article\"></div>\n</div>"